const memoizerMap = new Map();

export const memoizer = (fn) => {
    return async (...args) => {
        const key = JSON.stringify(args);
        if (memoizerMap.has(key)) {
            return memoizerMap.get(key);
        }
        const promise = fn(...args).catch((error) => {
            memoizerMap.delete(key);
            throw error;
        });

        memoizerMap.set(key, promise);
        return promise;
    };
};
